import React from 'react';

import editIcon from '../../../assets/edit_icon_gray.svg';

const ImgRadio = ({
  itemKey,
  title,
  value,
  name,
  onItemClick,
  selected,
  onEditClick,
  hide,
  icon,
}) => {
  const onLabelClick = (e) => {
    e.stopPropagation();
    onItemClick(value);
  };

  const onEditClickHandler = (e) => {
    e.stopPropagation();
    onEditClick(null);
  };

  return (
    <div
      key={`${value}-${itemKey}`}
      className={`imgRadio ${!selected && hide ? 'hide' : ''}`}
      onClick={onLabelClick}
    >
      <input
        type="radio"
        name={name}
        id={`${value}-${itemKey}`}
        checked={selected}
        readOnly
      />
      <div className="imgRadio__cont">
        <label className="imgRadio__img" htmlFor={`${value}-${itemKey}`}>
          <img src={icon} alt="banco BBVA" />
        </label>
        <div className="imgRadio__content">
          <p className="title u-mt-8">{title}</p>
          <button className="editBtn" onClick={onEditClickHandler}>
            <img src={editIcon} alt="icono editar" />
            <span>Editar</span>
          </button>
        </div>
      </div>
      <span className="imgRadio__checkmark"></span>
    </div>
  );
};

export default ImgRadio;
